module.exports = __webpack_public_path__ + "img/4.97c03727.jpg";